import {css} from 'lit';
export const styles = css`:host {
  --line-width: 2px;
  --area-opacity: 0.12;
  --marker-size: 7px;
  --surface-color: #fff;

  /* Points are placed as a plain fraction of the plot width, so the label row
     has to divide that width evenly too — a gap between labels would shift
     every centre off its point. */
  --bucket-gap: 0;
}

svg {
  display: block;
  width: 100%;
  height: 100%;
  overflow: visible;
}

.stroke {
  fill: none;
  stroke-width: var(--line-width);
  stroke-linecap: round;
  stroke-linejoin: round;
}

.area {
  opacity: var(--area-opacity);
}

.marker {
  position: absolute;
  width: var(--marker-size);
  height: var(--marker-size);
  border: 2px solid;
  border-radius: 50%;
  background-color: var(--surface-color);
  transform: translate(-50%, 50%);
}
`;
export default styles;
